import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from '@mdi/react';

const SvgContainer = styled.div`
  position: relative;
  padding: 4px;
  border-radius: 50%;
  background-color: transparent;
`;

const GeneralIcon = ({ rgb, icon, size }) => (
  <SvgContainer>
    <Icon
      path={icon}
      size={size}
      color={`rgb(${rgb[0]},${rgb[1]},${rgb[2]})`}
    />
  </SvgContainer>
);

GeneralIcon.propTypes = {
  size: PropTypes.number,
  icon: PropTypes.string.isRequired,
  rgb: PropTypes.arrayOf(PropTypes.number),
};

GeneralIcon.defaultProps = {
  size: 1,
  rgb: [0, 0, 0],
};

export default GeneralIcon;
